import { useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react';
import FormMaster from '../FormMaster'
import { CommonService } from "../../../services";
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next'

let firstRender = false
const Rating = inject("authenStore")(observer((props) => {
  const { t } = useTranslation(['rating', 'common'])
  let authenStore = props.authenStore
  let { getAccountAuth } = authenStore // STATE
  let auth = { action_user_id: getAccountAuth?.user_id, token_id: getAccountAuth?.access_token }

  const [optionStatus, setOptionStatus] = useState([])

  useEffect(() => {
    if (firstRender || !isEmpty(getAccountAuth)) {
      CommonService.getMasterData(auth, "common_status")
        .then((res: any) => {
          let common_status = res.result.common_status.map((item) => ({ label: item.status_name, value: item.status_code }))
          setOptionStatus(common_status)
        })
        .catch((err) => {
          console.log(`Load master data : ${err}`)
        })
    }
    else
      firstRender = true
  }, [getAccountAuth])

  return <FormMaster
    title={t('score_information')}
    tableConfig={{
      key: "rate_id",
      apiPath: "rate/list",
      allowDelete: {
        visible: false,
        key: "rate_id",
        apiPath: "rate/delete"
      },
      optionDeleteFag: true,
      defaultColumn: [],
      columns: [
        {
          dataField: 'no',
          caption: t('no'),
          width: 60,
          alignment: "center",
          allowFiltering: false
        },
        {
          dataField: 'rate_name',
          caption: t('topic'),
          allowFiltering: true
        },
        {
          dataField: 'point',
          caption: t('score'),
          allowFiltering: true
        },
        {
          dataField: 'status_name',
          caption: t('status'),
          allowFiltering: true
        },
        {
          dataField: 'updated_by',
          caption: t('edit_by'),
        }
      ],
      exportExcel: {
        fileName: t('score_information'),
        columnConfig: [
          { label: t('no'), value: 'no' },
          { label: t('topic'), value: 'rate_name' },
          { label: t('score'), value: 'point' },
          { label: t('status'), value: 'status_name' },
          { label: t('edit_by'), value: 'updated_by' }
        ]
      }
    }}
    formData={{
      rate_name: "",
      point: 0,
      status: "Y"
    }}
    modalConfig={{
      screenName: "rating",
      visible: true,
      title: t('score_information'),
      required: ["rate_name", "point"],
      fieldTypeNumber: ["point"],
      paramName: "rate_id",
      apiPath: {
        "get": '',
        "post": 'rate/add',
        "put": 'rate/update'
      },
      elements: [
        {
          fieldName: "rate_name",
          label: t('topic'),
          placeholder: t('topic'),
          required: true,
          inputType: "text",
          isOneRow: true
        },
        {
          fieldName: "point",
          label: t('score'),
          placeholder: t('score'),
          required: true,
          inputType: "number",
          isOneRow: true
        },
        {
          showSearch: false,
          fieldName: "status",
          label: t('status'),
          inputType: "select",
          required: true,
          defaultValue: "Y",
          options: optionStatus
        }
      ]
    }}
  />
}))

export default Rating